// Public entry point for the demo layer. Call bootstrapDemo() once, as early as
// possible, before the app makes any request. It is a no-op unless a demo mode
// is active, so it is always safe to call from the normal entry point.

import { IS_DEMO, IS_DEMO_REPLAY } from './config';
import { loadFixtures } from './fixtures';
import { installDemoFetch } from './installFetch';

export { IS_DEMO, IS_DEMO_REPLAY, IS_DEMO_RECORD } from './config';

let started = false;

export async function bootstrapDemo(): Promise<void> {
  if (!IS_DEMO || started) return;
  started = true;

  // Replay needs fixtures in memory before any /api call is answered.
  if (IS_DEMO_REPLAY) {
    await loadFixtures();
  }

  installDemoFetch();

  // A previously-installed service worker (from visiting the real app on this
  // origin) would intercept /api before our shim — tear it down in demo mode.
  if ('serviceWorker' in navigator) {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    } catch {
      /* best effort */
    }
  }
}
